
/* eslint-disable no-param-reassign */
export const setVersion = (state, version) => {
  state.version = version; //eslint-disable-line
};
export const setConfig = (state, data) => {
  state.config = data; //eslint-disable-line
};
export const setInit = (state, bool) => {
  state.init = bool; //eslint-disable-line
};
export const setTokenPrices = (state, products) => {
  products.forEach((product) => {
    product.price = window.products[product.globalId].priceElement?.innerText || '';
    if (window.products[product.globalId].priceElement?.innerText === undefined) console.error('Price token not found for product', product.globalId);
  });
};
export const setMobile = (state, bool) => {
  state.isMobile = bool; //eslint-disable-line
};
export const setBrowser = (state, val) => {
  state.browser = val; //eslint-disable-line
};

export const setCurrentWave = (state, wave) => {
  state.wave = wave;
};

// Set the filter type and default value for that filter type
/* eslint-enable no-param-reassign */
export const setFilterType = (state, type = undefined) => {
  switch (type) {
    case 'collection':
      state.filters.filterType = type; //eslint-disable-line
      state.filters.filterValue = "batman"; //eslint-disable-line
      break;
    case 'value':
    default:
      state.filters.filterType = 'value'; //eslint-disable-line
      state.filters.filterValue = 10; //eslint-disable-line
      break;
  }
};

export const setFilterValue = (state, value = undefined) => {
  if (value) {
    const v = state.filters.filterType === "value" ? parseInt(value, 10) : value; //eslint-disable-line
    state.filters.filterValue = v; //eslint-disable-line
  } else {
    state.filters.filterValue = undefined; //eslint-disable-line
  }
};
